type localesKeys__Navigation = {
    techRadarNavItem__label: string;
    storybookNavItem__label: string;
    downloadNavItem__label: string;
    contactNavItem__label: string;
    myCvNavItem__label: string;
    interviewNavItem__label: string;
    techRadarNavItem__hint: string;
    storybookNavItem__hint: string;
    downloadNavItem__hint: string;
    contactNavItem__hint: string;
    myCvNavItem__hint: string;
    interviewNavItem__hint: string;
}

const ruLocale__Navigation: localesKeys__Navigation = {
    techRadarNavItem__label: 'Техн Радар',
    interviewNavItem__label: 'ИИнтервью',
    storybookNavItem__label: 'StoryBook',
    downloadNavItem__label: 'Скачать',
    contactNavItem__label: 'Контакт',
    myCvNavItem__label: 'Моё CV',
    techRadarNavItem__hint: 'Интерактивная история моих технологий с 1997 года: что использую, что пробовал, что и почему бросил',
    interviewNavItem__hint: 'Экспериментальный раздел: ИИ-чат, отвечающий на вопросы о моём опыте',
    storybookNavItem__hint: 'Витрина UI-компонентов этого сайта',
    downloadNavItem__hint: 'Скачать резюме в PDF на текущем языке',
    contactNavItem__hint: 'Визитка',
    myCvNavItem__hint: 'Полное резюме: таймлайн карьеры, проекты и достижения',
};

const enLocale__Navigation: localesKeys__Navigation = {
    techRadarNavItem__label: 'Tech Radar',
    interviewNavItem__label: 'AInterview',
    storybookNavItem__label: 'StoryBook',
    downloadNavItem__label: 'Download',
    contactNavItem__label: 'Contact',
    myCvNavItem__label: 'My CV',
    techRadarNavItem__hint: 'An interactive history of my technologies since 1997: what I use, what I tried, what I dropped and why',
    interviewNavItem__hint: 'Experimental: an AI chat that answers questions about my experience',
    storybookNavItem__hint: "A showcase of this site's UI components",
    downloadNavItem__hint: 'Download the résumé as a PDF in the current language',
    contactNavItem__hint: 'My business card',
    myCvNavItem__hint: 'The full résumé: career timeline, projects and achievements',
};

export { ruLocale__Navigation, enLocale__Navigation };
export type { localesKeys__Navigation };
